import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods, Quote } from '@sm360/widget-commons-vehicle';

import ProtectionCategory from 'protections/components/ProtectionCategory/ProtectionCategory.jsx';

import 'protections/components/Protections/Protections.scss';

class Protections extends React.Component {
    componentWillMount() {
        this.props.actions.loadQuoteProtections(this.props.quoteId);
    }

    render() {
        const { isLease, selectedFinanceTerm, taxesFactor, taxCodes, protections } = this.props;

        const protectionCategories = protections.map((protection) => {
            return (
                <ProtectionCategory
                    key={protection.id}
                    isLease={isLease}
                    selectedFinanceTerm={selectedFinanceTerm}
                    taxesFactor={taxesFactor}
                    taxCodes={taxCodes}
                    protectionCategory={protection}
                    openProtectionCategory={this.props.actions.openProtectionCategory}
                    nextPreviousProtectionCategory={this.props.actions.nextPreviousProtectionCategory}
                    selectProtectionPackage={this.props.actions.selectProtectionPackage}
                />
            );
        });

        return (
            <div>
                <h2 className="sr-title-1">{LocaleService.t('PROTECTIONS.TITLE')}</h2>
                <h3 className="sr-subtitle-1">{LocaleService.t('PROTECTIONS.SUB_TITLE')}</h3>
                <div className="protections__inner-content has-primary-background">{protectionCategories}</div>
            </div>
        );
    }
}

Protections.defaultProps = {
    protections: [],
};

Protections.propTypes = {
    actions: PropTypes.shape({
        openProtectionCategory: PropTypes.func.isRequired,
        nextPreviousProtectionCategory: PropTypes.func.isRequired,
        selectProtectionPackage: PropTypes.func.isRequired,
        loadQuoteProtections: PropTypes.func.isRequired,
    }),
    isLease: PropTypes.bool.isRequired,
    protections: PropTypes.arrayOf(PropTypes.instanceOf(Quote.QuoteItemCategoryModel)),
    quoteId: PropTypes.string.isRequired,
    selectedFinanceTerm: PropTypes.instanceOf(PurchaseMethods.TermModel),
    taxCodes: PropTypes.string.isRequired,
    taxesFactor: PropTypes.number.isRequired,
};

Protections.displayName = 'Protections';

export default Protections;



// WEBPACK FOOTER //
// ./src/components/Protections/Protections.jsx